export default __webpack_public_path__ + "static/char-s-15-en-c82f9b15e0047011b41b1029f44af152.webp";